module.exports = __webpack_public_path__ + "img/freeze.bb388874.svg";